<template>
  <v-select
    :value="value"
    @input="$emit('input', $event)"
    :label="label"
    :loading="loading"
    :items="termos"
    item-value="id"
    item-text="titulo"
    :hint="hint"
    :persistent-hint="!!hint"
  >
    <template v-slot:item="{ item }">
      <v-list-item-content>
        <v-list-item-title>{{ item.titulo }}</v-list-item-title>
        <v-list-item-subtitle>{{ item.descricao }}</v-list-item-subtitle>
      </v-list-item-content>
    </template>
    <template v-slot:selection="{ item }">
      <v-list-item-content>
        <v-list-item-title>{{ item.titulo }}</v-list-item-title>
        <v-list-item-subtitle>{{ item.descricao }}</v-list-item-subtitle>
      </v-list-item-content>
    </template>
  </v-select>
</template>

<script>
export default {
  props: ["value", "label", "dicionario", "hint"],
  data() {
    return {
      termos: [],
      loading: true,
    };
  },
  mounted() {
    this.carregarTermos();
  },
  methods: {
    async carregarTermos() {
      this.loading = true;
      try {
        this.termos = await this.$store.dispatch("taxonomia/listarTermos", {
          dicionario: this.dicionario,
          opcoes: {},
        });
      } catch (err) {
        console.log(err);
        this.$store.commit("ui/setSnackbar", {
          text: `Não foi possível carregar a lista de termos para ${this.label}`,
        });
      }
      this.loading = false;
    },
  },
};
</script>
